import React from 'react';

const MAX_HEADLINES = 6;

export const NewsBreakingBar = ({ articles, isLoading }) => {
  const headlines = articles.slice(0, MAX_HEADLINES);
  if (!isLoading && headlines.length === 0) return null;

  return (
    <div className="bg-white border border-slate-200/90 rounded-2xl overflow-hidden shadow-xs flex items-center my-6">
      {/* Breaking Tag */}
      <div className="flex-shrink-0 bg-rose-600 text-white font-black text-xs px-3.5 py-2.5 flex items-center gap-1.5 uppercase tracking-wider">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-300 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
        </span>
        <span>BREAKING</span>
      </div>

      {/* Marquee Headlines */}
      <div className="flex-1 overflow-hidden relative group py-2 px-4">
        {isLoading ? (
          <div className="h-4 w-2/3 bg-slate-100 rounded animate-pulse" />
        ) : (
          <div className="flex items-center space-x-8 whitespace-nowrap animate-marquee group-hover:[animation-play-state:paused] text-xs font-semibold text-slate-800">
            {/* Rendered twice so the marquee loops seamlessly */}
            {[...headlines, ...headlines].map((article, idx) => (
              <div key={`${article.id}-${idx}`} className="inline-flex items-center gap-2">
                {article.url ? (
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    tabIndex={idx < headlines.length ? 0 : -1}
                    className="hover:text-indigo-600 transition-colors"
                  >
                    {article.title}
                  </a>
                ) : (
                  <span>{article.title}</span>
                )}
                <span className="text-slate-300 font-normal ml-3">•</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsBreakingBar;
